<script>
  export let scale = 1;
  export let color = "#323232";
</script>

<svg width={40 * scale} height={40 * scale} viewBox="-12 -12 35 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill={color} d="M1.25 7.29901C0.249999 6.72166 0.250001 5.27828 1.25 4.70093L8.75 0.370802C9.75 -0.206548 11 0.51514 11 1.66984V10.3301C11 11.4848 9.75 12.2065 8.75 11.6291L1.25 7.29901Z" />
</svg>

